import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-974f0be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Laufzeit:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Preis:", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { Subscription } from "@/store/model";
import { PropType, ref, watch } from "vue";
import BaseButton from "@/components/base/base-button.vue";
import BaseInput from "@/components/base/base-input.vue";
import { subscriptionStorageModule } from "@/store/subscription-storage";


export default /*#__PURE__*/_defineComponent({
  props: {
  subscription: {
    type: Object as PropType<Subscription>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const isEditing = ref(false);
const shakeButton = ref(false);



const newPrice = ref(props.subscription.price);
const priceIsValid = ref(true);

watch(
  () => props.subscription,
  () => {
    newPrice.value = props.subscription.price;
  }
);

function toggleEditing() {
  if (isEditing.value) {
    saveUpdate();
  } else {
    startEditing();
  }
}

function startEditing() {
  isEditing.value = true;
}

function saveUpdate() {
  if (priceIsValid.value) {
    const newSubscription = JSON.parse(JSON.stringify(props.subscription));
    newSubscription.price = newPrice.value;
    subscriptionStorageModule.update(newSubscription);

    isEditing.value = false;
  } else {
    // Shake button to indicate invalid value
    shakeButton.value = true;
    setTimeout(() => {
      shakeButton.value = false;
    }, 700);
  }
}

function validatePrice(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  if (value !== "") {
    priceIsValid.value = true;
  } else {
    priceIsValid.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _hoisted_2,
        _createElementVNode("td", null, _toDisplayString(__props.subscription.duration), 1)
      ]),
      _createElementVNode("tr", null, [
        _hoisted_3,
        (!isEditing.value)
          ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(__props.subscription.price) + " € pro Jahr", 1))
          : (_openBlock(), _createElementBlock("td", _hoisted_5, [
              _createVNode(BaseInput, {
                width: "60px",
                modelValue: newPrice.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPrice).value = $event)),
                valid: priceIsValid.value,
                onBlur: validatePrice,
                type: "number"
              }, null, 8, ["modelValue", "valid"])
            ]))
      ])
    ]),
    _createVNode(BaseButton, {
      title: isEditing.value ? 'Speichern' : 'Bearbeiten',
      class: _normalizeClass({ buttonSave: isEditing.value, shake: shakeButton.value }),
      onClick: toggleEditing
    }, null, 8, ["title", "class"])
  ]))
}
}

})